<template>
  <div class="form-group bs-form-switch">
    <div class="form-content --truncate ${disabled ? '--disabled' : ''} ${labels.length === 0 ? '--noborder' : ''}">
      <div class="custom-control custom-switch ${controlClass}">
        <input id="${controlId}" type="checkbox" class="custom-control-input" checked.bind="checked" disabled.bind="disabled" focus.bind="hasfocus" blur.trigger="blur()">
        <label class="custom-control-label" for="${controlId}">${text}</label>
      </div>
    </div>
    <small class="form-label" repeat.for="label of labels">${label}</small>
  </div>
</template>
